import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import RoleListLayer from "../components/RoleListLayer";

const RoleListPage = () => {
  return (
    <MasterLayout>

      <RoleListLayer />
    </MasterLayout>
  );
};

export default RoleListPage;
